import { render, staticRenderFns } from "./onegc.vue?vue&type=template&id=2cae49d3&scoped=true&"
import script from "./onegc.vue?vue&type=script&lang=js&"
export * from "./onegc.vue?vue&type=script&lang=js&"
import style0 from "./onegc.vue?vue&type=style&index=0&id=2cae49d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae49d3",
  null
  
)

export default component.exports